




























import Vue from "vue";
import AmountInput from "@/components/AmountInput.vue";
import config from "@/configs";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "PaymentForm",
  components: { AmountInput },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("checkout", ["getLoading"]),
  },
  data() {
    return {
      company: config?.settings.company || "",
      currency: config?.settings.customerSettings?.defaultCurrency,
      amount: 0,
    };
  },
  methods: {
    ...mapActions("checkout", ["navigateToCheckoutSession"]),
    onChangeAmount(amount: number) {
      this.amount = amount;
    },
    onCheckout() {
      const payload = {
        success_url: window.location.href + "?success={CHECKOUT_SESSION_ID}",
        cancel_url: window.location.href,
        mode: "payment",
        customer: this.customerId,
        line_items: [
          {
            quantity: 1,
            price_data: {
              currency: this.currency,
              unit_amount: this.amount,
              product_data: {
                name: this.$t("customers.productName"),
              },
            },
          },
        ],
      };

      console.log(payload);

      this.navigateToCheckoutSession(payload);
    },
  },
});
